import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const STATUS_LABEL = { pending: "In attesa", failed: "Da riprovare", released: "Rilasciato" };

export default function PayoutsPanel() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/admin/payouts"); setData(data); } catch {}
  };
  useEffect(() => { load(); }, []);

  const release = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/payouts/release"); toast.success(`Rilasciati ${data.released} su ${data.checked}`); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="payouts-panel" className="border border-neutral-200 rounded-2xl p-4">
      <h2 className="font-display font-bold mb-1">Ripartizione automatica pagamenti</h2>
      <p className="text-xs text-neutral-500 mb-3">Il 10% di ogni pagamento resta sul conto Stripe ENBISSY, il 90% va al venditore tramite Stripe Connect appena collega il conto. Le commissioni di affiliazione (10% del margine) partono dal 10% ENBISSY. I bonifici bancari arrivano di norma entro 5–7 giorni lavorativi (tempi Stripe).</p>
      {data && !data.connect_enabled && (
        <div data-testid="connect-disabled-warning" className="rounded-xl bg-amber-50 border border-amber-200 text-amber-800 text-xs p-3 mb-3">
          Stripe Connect non è ancora attivato sul conto ENBISSY: i venditori non possono collegare il conto e le loro quote restano in attesa. Attivalo dalla Dashboard Stripe → Connect → Inizia.
        </div>
      )}
      <div className="grid grid-cols-3 gap-2 mb-3">
        <div className="rounded-xl bg-neutral-50 p-3"><p className="text-xs text-neutral-500">Tuo 10%</p><p data-testid="payouts-platform-total" className="font-display font-extrabold">€{(data?.platform_total ?? 0).toFixed(2)}</p></div>
        <div className="rounded-xl bg-neutral-50 p-3"><p className="text-xs text-neutral-500">Rilasciati</p><p data-testid="payouts-released-total" className="font-display font-extrabold">€{(data?.released_total ?? 0).toFixed(2)}</p></div>
        <div className="rounded-xl bg-neutral-50 p-3"><p className="text-xs text-neutral-500">In attesa</p><p data-testid="payouts-pending-total" className="font-display font-extrabold">€{(data?.pending_total ?? 0).toFixed(2)}</p></div>
      </div>
      <div className="space-y-2 mb-3">
        {(data?.payouts || []).slice(0, 20).map((p) => (
          <div key={p.id} data-testid={`payout-${p.id}`} className="flex items-center justify-between text-sm border border-neutral-100 rounded-xl px-3 py-2">
            <div className="min-w-0">
              <p className="font-medium truncate">{p.user?.name || "—"} <span className="text-neutral-400">· {p.role === "seller" ? "venditore" : "affiliazione"}</span></p>
              <p className="text-xs text-neutral-500 truncate">{p.title}{p.error ? ` — ${p.error}` : ""}</p>
            </div>
            <div className="text-right pl-2">
              <p className="font-display font-bold">€{p.amount.toFixed(2)}</p>
              <p className={`text-xs ${p.status === "released" ? "text-green-700" : "text-amber-700"}`}>{STATUS_LABEL[p.status] || p.status}</p>
            </div>
          </div>
        ))}
        {data && data.payouts.length === 0 && <p className="text-xs text-neutral-400">Nessun pagamento da ripartire ancora.</p>}
      </div>
      {data && data.pending_total > 0 && (
        <Button data-testid="release-payouts-btn" onClick={release} disabled={busy} variant="outline" className="w-full h-11 rounded-full">
          {busy ? "…" : "Rilascia ora le quote in attesa"}
        </Button>
      )}
    </div>
  );
}
